/**
 * An enum which indicates the type of search that Headless is managing.
 *
 * @public
 */
export var SearchTypeEnum;
(function (SearchTypeEnum) {
    /**
     * Indicates that headless is managing universal search.
     */
    SearchTypeEnum["Universal"] = "universal";
    /**
     * Indicates that headless is managing vertical search.
     */
    SearchTypeEnum["Vertical"] = "vertical";
})(SearchTypeEnum || (SearchTypeEnum = {}));
//# sourceMappingURL=searchType.js.map